import { FC, useState, useEffect } from "react";
import { CardContent, Grid, InputAdornment, MenuItem, Select, SelectChangeEvent, Tooltip } from "@mui/material";
import { StyledCard } from '../AccountBasicInfo/AccountBacisInfo.styles';
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import CustomSelect, { IOptions } from "../FormFields/CustomSelect";
import PreviewIcon from '@mui/icons-material/Preview';
import { fetchTemplates} from '../../store/invoiceStore/invoiceThunk';
import { Utils, InvoiceRoute, VocuherCategory, VocuherTypes } from "../../utils/common-utils";

interface PayToProps {
  invoiceId: string | undefined;
  invoiceStatus: string;
  invoiceDocType: string;
  defaultTemplate?: string;
  onChangeTemplate?: (data: any, templateOption?: any) => void;
}

// Template Select component
const TemplateSelect: FC<PayToProps> = ({invoiceId, invoiceStatus, invoiceDocType, defaultTemplate, onChangeTemplate}) => {
  const dispatch = useAppDispatch();
  const [templateOptions, setTemplateOptions] = useState<IOptions[]>([]);
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const invoiceDetails = useAppSelector(state => state.invoices.invoiceDetails);
  const estimateDetails = useAppSelector(state => state.estimates.estimateDetails);
  const creditNoteDetails = useAppSelector(state => state.creditNotes.creditNoteDetails);

   //Method to handle Preview button click.
   const onPreview = () => {
    if(invoiceId) {
      const previewLink = `/invoice/${invoiceId}/view?templateId=${selectedTemplate}`;
      window.open(previewLink, '_blank');
    }
  };

  useEffect(() => {
    const setInitialData = () => {
      if(invoiceId) {
        if (invoiceDocType == "sale-estimate") {
          setSelectedTemplate(estimateDetails.pdfTemplate)
        } else if (invoiceDocType == "sale-credit-note") {
          setSelectedTemplate(creditNoteDetails.pdfTemplate)
        } else {
          setSelectedTemplate(invoiceDetails.pdfTemplate)
        }
       
      }
    }
    if (invoiceDocType == "sale-estimate") { 
      if (Object.keys(estimateDetails).length > 0 ) setInitialData();
    } else if (invoiceDocType == "sale-credit-note") {
      if (Object.keys(creditNoteDetails).length > 0 ) setInitialData();
    } else {
      if (Object.keys(invoiceDetails).length > 0 ) setInitialData();
    }
  }, [invoiceId, estimateDetails, creditNoteDetails, invoiceDetails]);

  // Populate Template option on form load.
  useEffect(() => {
    const getTemplates = async () => {
      if (!templateOptions.length) {
        const data: any = await dispatch(fetchTemplates());

        if(data.payload.length>0) {
          const opts = data.payload.map((c: any) => {
            // if(!invoiceId && invoiceDocType==="sale-invoice" && c.template==='Default-Invoice-1') {
            //   console.log("setting up invoice template");
            //   setSelectedTemplate(c._id);
            // } else if (!invoiceId && invoiceDocType==="sale-estimate" && c.template==='Default-Estimate' ) {
            //   console.log("setting up sale-estimate template");
            //   setSelectedTemplate(c._id);
            // } else if (!invoiceId && invoiceDocType==="sale-credit-note" && c.template==='Default-Credit-Note' ) {
            //   console.log("setting up sale-credit-note template");
            //   setSelectedTemplate(c._id);
            // }

            // console.log(invoiceDocType);
            // console.log(c.template);

            if (!invoiceId && c.template==='Default-Invoice-1') {
              console.log("setting up invoice template");
              setSelectedTemplate(c._id);
              console.log("defaultTemplate inside ==> ", defaultTemplate);
              if(onChangeTemplate && defaultTemplate && defaultTemplate !='') {
                onChangeTemplate(defaultTemplate, { label: c.template, value: c._id });
              } else if (onChangeTemplate) {
                onChangeTemplate(c._id, { label: c.template, value: c._id });
              }
            }

            let defaults = ['Default-Invoice-1', 'Default-Estimate', 'Default-Credit-Note']
            return { label: c.template, value: c._id, disable: c.template === defaults.includes(c.template) ? false : true }
          });
          setTemplateOptions(opts);

          if (defaultTemplate && onChangeTemplate) {
            const matched = opts.find((t: any) => t.value === defaultTemplate);
            if (matched) {
              onChangeTemplate(defaultTemplate, matched);
            }
          }
        }
      }
    }
    getTemplates();
    console.log("defaultTemplate ==> ", defaultTemplate);
    if(templateOptions && defaultTemplate) {
      setSelectedTemplate(defaultTemplate);
      const matched = templateOptions.find((t: any) => t.value === defaultTemplate);
      if (matched && onChangeTemplate) {
        onChangeTemplate(defaultTemplate, matched);
      }
    }
  }, [dispatch, templateOptions, invoiceId, defaultTemplate]);

  return (
    <>{templateOptions.length>0 && <>
    <h5 className='c-label'>Select Voucher Template</h5>
    <Select
                        className='c-text-field' 
                        
                        disableUnderline
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              border: "1.5px solid #e9ecf1",
                              // width: 255,
                              // marginLeft:'-29px !important',
                              boxShadow: 'none',
                              borderRadius: '5px'
                            }
                          }
                          }}
                          startAdornment={
                            <InputAdornment position="start" style={{paddingBottom:3}}>
                              <Tooltip title="Preview"><PreviewIcon style={{ opacity: (!invoiceId)? 0.5 : '', cursor: 'pointer' }} onClick={onPreview} fontSize="medium" /></Tooltip>
                            </InputAdornment>
                          }
                        style={{width:'100%'}}
                        value={selectedTemplate}
                        onChange={(event: SelectChangeEvent<any>) => {
                          const val = event.target.value;
                          setSelectedTemplate(val);
                          const matched = templateOptions.find((t) => t.value === val);
                          if(onChangeTemplate) onChangeTemplate(val, matched)
                        }}
                        size='small'
                        variant='outlined'
                        sx={{
                          boxShadow: "none",
                          // fontSize:12,
                          '& .MuiOutlinedInput-input': {p: 0.5},
                          // '& .MuiSelect-select': { p:0 },
                          marginBottom:'3px',
                          ".MuiOutlinedInput-notchedOutline": { border: 0 },
                          "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                            {
                              border: 0,
                            },
                          "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                            {
                              border: 0,
                            },
                        }}
                        >
                        {templateOptions && templateOptions.map((option)=>
                           <MenuItem value={option.value} key={option.value}>{option.label}</MenuItem>
                         )}
                         </Select>
                         </>}
      {/* <StyledCard>
        <CardContent style={{ paddingBottom: 0 }}>
          <Grid container style={{ justifyContent: 'space-between', padding: '0px 6px', borderRadius: '5px', backgroundColor: '#eaecf1' }}>
            <Grid item xs={12} style={{ display: 'flex', alignItems: 'center' }}>
              {templateOptions.length>0 && <><CustomSelect
                name="pdfTemplate"
                label="Select Invoice Template"
                id="template"
                variant="standard"
                options={templateOptions}
                value={selectedTemplate}
                disabled={(invoiceStatus === 'DRAFT')? false : true}
                onChange={(event: SelectChangeEvent<any>) => {
                  // setSelectedTemplate(event.target.value);
                  setSelectedTemplate(event.target.value)
                }} /> <Tooltip title="Preview"><PreviewIcon style={{ opacity: (!invoiceId)? 0.5 : '', cursor: 'pointer', marginTop: '16px' }} onClick={onPreview} fontSize="medium" /></Tooltip> </>}
            </Grid>
          </Grid>
        </CardContent>
      </StyledCard> */}
    </>
    );
};

export default TemplateSelect;